export function buildUrl(baseUrl: string, params: object): string {
  const url = new URL(baseUrl);
  for (const [key, value] of Object.entries(params)) {
    if (typeof value !== 'undefined') {
      url.searchParams.set(key, value.toString());
    }
  }
  return url.href;
}
